module.exports = __webpack_public_path__ + "static/media/ods_1_pt.e2909fd7.jpg";